import { AbstractControl, ValidationErrors, ValidatorFn, FormGroup } from "@angular/forms";
import { IAppValidator } from "./validator";

export const equalsPhonesErrorKey = "telefoneIgualError";

export class EqualsPhonesValidator implements IAppValidator {
  execute(telefonePessoaCompleto?: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const telefoneReferenciaDdd = control.value['pessoa.referencia.telefone.ddd'];
      const telefoneReferenciaNumero = control.value['pessoa.referencia.telefone.numero'];
      const telefoneReferenciaCompleto = `${telefoneReferenciaDdd}${telefoneReferenciaNumero}`
      const telefonePessoaCompletoValue = telefonePessoaCompleto || '';

      if (telefoneReferenciaNumero && telefoneReferenciaDdd &&
        telefoneReferenciaCompleto === telefonePessoaCompletoValue) {

        return {
          [equalsPhonesErrorKey]: "O telefone de referência não pode ser igual ao telefone da pessoa.",
        };

      }

      return null;

    };
  }
}

export const equalsPhonesValidator = new EqualsPhonesValidator();